import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordConfirm, PatronValidators } from '@app/shared/components/form/validators';
import { ToastService } from '@teorema/patron';
import { AccessType } from 'src/app/models/bw-user.model';
import { CompanyGroup } from 'src/app/models/company-group.model';
import { System } from 'src/app/models/core-config.model';
import { User } from 'src/app/models/user.model';
import { utils } from 'src/app/shared';
import { AuthComponent } from '../auth.component';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './register-company.component.html',
  standalone: false,
})
export class RegisterCompanyComponent implements AfterViewInit {
  registerForm: FormGroup;
  loading: boolean = false;
  isPraxis: boolean = false;
  user?: User;
  companyGroup?: CompanyGroup;

  @ViewChild(AuthComponent) authComponent?: AuthComponent;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService
  ) {
    this.isPraxis = this.authService.checkSystem([System.PRAXIS]);

    this.registerForm = this.formBuilder.group(
      {
        cnpj: ['', [Validators.required, PatronValidators.cnpj]],
        name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        password_confirmation: ['', [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [PasswordConfirm('password', 'password_confirmation')],
      }
    );
  }

  ngAfterViewInit(): void {
    if (!this.isPraxis) {
      setTimeout(() => {
        this.toastService.show({
          color: 'warn',
          message: 'O cadastro de usuário não está disponível para esse painel',
        });
        this.router.navigate(['/auth']);
      }, 1000);
    }
  }

  async onSubmit() {
    this.loading = true;
    const response = await this.authService
      .registerCompany(this.registerForm.value)
      .catch(err => {
        if (!err?.messageShown)
          this.toastService.show({
            color: 'error',
            message: 'Houve um erro ao cadastrar a empresa',
          });
      })
      .finally(() => {
        this.loading = false;
      });

    if (response) {
      if (response?.bw_user?.id) {
        this.user = response.bw_user;
      }
      if (response?.company_group?.id) {
        this.companyGroup = response.company_group;
      }

      this.handleLogin();
    }
  }

  async handleLogin() {
    if (!this.user) return;
    const { email } = this.user;
    const { password } = this.registerForm.value;
    if (!email || !password) return;

    this.authComponent?.authForm.patchValue({ email, password });
    await this.authComponent?.onSubmit(true);

    const companyGroups = this.authComponent?.companyGroups;
    if (companyGroups && companyGroups?.length > 1) {
      const companyGroup = companyGroups.find(cg => cg.id == this.companyGroup?.id);
      if (companyGroup) {
        utils.setAccessType(AccessType.User);
        utils.setCompanyGroup(companyGroup);
      }
    }
  }
}
